import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {WorkPermitTypeForm} from "./WorkPermitTypeForm";


export const WorkPermitTypeCreate = (props: CreateProps) => {
    return (
        <CustomCreate {...props}>
            <WorkPermitTypeForm/>
        </CustomCreate>
    )
}